import { createSlice } from "@reduxjs/toolkit";

const defaultChatbotAccess = {
  showChatbot: false,
  showChatbotBanner: false,
  chatbotBetaEnrolled: false,
  chatbotBetaSlotsRemaining: null,
  betaSlotsFull: false,
  highlightAddToAiChat: false,
};

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    userDetails: null,
    billingDetails: null,
    subscriptionRevision: 0,
    currencyCode: null,
    chatbotAccess: defaultChatbotAccess,
  },
  reducers: {
    setDetails(state, action) {
      state.userDetails = action.payload.userDetails;
    },
    setBillingDetails(state, action) {
      state.billingDetails = action.payload.billingDetails;
    },
    noteSubscriptionChanged(state) {
      state.subscriptionRevision += 1;
    },
    setCurrencyCode(state, action) {
      state.currencyCode = action.payload.currencyCode;
    },
    setChatbotAccessFromAccount(state, action) {
      const account = action.payload ?? {};
      const keepHighlight = state.chatbotAccess.highlightAddToAiChat;
      state.chatbotAccess = {
        showChatbot: Boolean(
          account.showChatbot ?? account.chatbotBetaEnrolled
        ),
        showChatbotBanner: Boolean(account.showChatbotBanner),
        chatbotBetaEnrolled: Boolean(account.chatbotBetaEnrolled),
        chatbotBetaSlotsRemaining:
          account.chatbotBetaSlotsRemaining ??
          account.slotsRemaining ??
          null,
        betaSlotsFull: false,
        highlightAddToAiChat: keepHighlight,
      };
    },
    setChatbotAccessFromEnroll(state, action) {
      const payload = action.payload ?? {};
      const enrolled = Boolean(payload.enrolled);
      state.chatbotAccess = {
        showChatbot: Boolean(payload.showChatbot ?? enrolled),
        showChatbotBanner: Boolean(payload.showBanner),
        chatbotBetaEnrolled: enrolled,
        chatbotBetaSlotsRemaining: payload.slotsRemaining ?? null,
        betaSlotsFull: false,
        highlightAddToAiChat: true,
      };
    },
    setChatbotBetaSlotsFull(state) {
      state.chatbotAccess = {
        ...state.chatbotAccess,
        showChatbot: false,
        showChatbotBanner: false,
        chatbotBetaEnrolled: false,
        chatbotBetaSlotsRemaining: 0,
        betaSlotsFull: true,
      };
    },
    revokeChatbotAccess(state) {
      state.chatbotAccess = {
        ...state.chatbotAccess,
        showChatbot: false,
        showChatbotBanner: false,
        chatbotBetaEnrolled: false,
        highlightAddToAiChat: false,
      };
    },
    clearAddToAiChatHighlight(state) {
      state.chatbotAccess.highlightAddToAiChat = false;
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice;
